import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../Shared/DeleteModal";
import { Button, Modal } from "react-bootstrap";

const MilestoneActions = ({
  itemId,
  setItemId,
  item,
  setShowAdd,
  handleMarkMilestoneComplete,
  setDeleteId,
  setShowDelete,
}) => {
  const navigate = useNavigate();
  const milestoneActionOptions = [
    { value: "edit", label: "Edit" },
    { value: "delete", label: "Delete" },
    { value: "raise_invoice", label: "Raise Invoice" },
    { value: "mark_complete", label: "Mark Complete" },
    { value: "mark_incomplete", label: "Mark Incomplete" },
  ];

  const [milestoneAction, setMilestoneAction] = useState("");
  const [show, setShow] = useState(false);
  const handleChange = (selectedOption) => {
    setItemId(itemId);
    if (selectedOption === "raise_invoice") {
      if (item?.status !== "COMPLETED") {
        setShow(true);
      } else {
        navigate(
          `/invoices/add?project=${item?.project}&milestone=${item?.id}`
        );
      }
    } else if (selectedOption === "mark_complete") {
      setItemId(itemId);
      handleMarkMilestoneComplete(item);
    } else if (selectedOption === "mark_incomplete") {
      setItemId(itemId);
      handleMarkMilestoneComplete(item, "ACTIVE");
    } else if (selectedOption === "edit") {
      setShowAdd(true);
    } else if (selectedOption === "delete") {
      setDeleteId(itemId);
      setShowDelete(true);
    }
  };
  const filteredMilestoneActionOptions =
    item?.payment_status &&
    (item?.payment_status === "PAID" ||
      item?.payment_status === "PARTIALLY PAID")
      ? item?.status === "COMPLETED"
        ? milestoneActionOptions.filter(
            (option) =>
              option.value !== "mark_complete" &&
              option.value !== "mark_incomplete"
          )
        : milestoneActionOptions.filter(
            (option) => option.value !== "mark_incomplete"
          )
      : item?.status === "COMPLETED"
      ? milestoneActionOptions.filter(
          (option) => option.value !== "mark_complete"
        )
      : milestoneActionOptions.filter(
          (option) => option.value !== "mark_incomplete"
        );
  return (
    <>
      <select
        value={milestoneAction}
        onChange={(e) => handleChange(e.target.value)}
        style={{
          width: "100%",
          border: "0px",
          boxShadow: "0px",
          backgroundColor: "#EFF6FA",
          borderRadius: "5px",
          paddingRight: "0px",
          paddingLeft: "0px",
        }}
        className={`w-100 p-1 border fs-16 focus-none px-0 ${
          milestoneAction === "" ? "text-para" : ""
        }`}
      >
        <option key={""} value="" disabled>
          Select
        </option>
        {filteredMilestoneActionOptions?.map((item, index) => (
          <option className="p-1" key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
      {show && (
        <Modal
          centered
          show={show}
          onHide={() => setShow(false)}
          className="d-flex justify-content-center align-items-center"
        >
          <div className="bg-white rounded p-4" style={{ minWidth: "400px" }}>
            <h5 className="fw-bold text-center">
              {"Mark Milestone Complete?"}
            </h5>
            <p className="text-muted text-center my-5">
              This milestone is not marked as complete. Would you like to mark
              it as complete before raising the invoice?
            </p>
            <div className="d-flex justify-content-center gap-3">
              <Button
                variant="outline-secondary"
                onClick={() => {
                  setShow(false);
                  navigate(
                    `/invoices/add?project=${item?.project}&milestone=${item?.id}`
                  );
                }}
              >
                No, Continue
              </Button>
              <Button
                variant="primary"
                onClick={async () => {
                  await handleMarkMilestoneComplete(item);
                  setShow(false);
                  navigate(
                    `/invoices/add?project=${item?.project}&milestone=${item?.id}`
                  );
                }}
              >
                Yes, Mark Complete
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default MilestoneActions;
